/**
 * input theme
 * @see https://github.com/chakra-ui/chakra-ui/blob/%40chakra-ui/react%403.0.0/packages/react/src/theme/recipes/input.ts
 */
import { defineRecipe } from '@chakra-ui/react';
export const input = defineRecipe({
    base: {},
    variants: {
        variant: {
            plain: {
                h: '24px',
                minW: '24px',
                bg: 'transparent',
                border: 'none',
                focusVisibleRing: 'none',
                px: 0,
                _invalid: {
                    color: 'state.error',
                },
            },
            flushed: {
                borderBottomWidth: '2px',
                borderBottomColor: 'text.default',
                _focusVisible: {
                    borderColor: 'text.default',
                    boxShadow: 'none',
                },
            },
        },
        size: {
            md: {
                textStyle: 'body1',
                _placeholder: {
                    color: 'text.secondary',
                    textStyle: 'body1',
                },
            },
        },
    },
    compoundVariants: [],
    defaultVariants: {
        variant: 'plain',
    },
});
